import React from "react";
import InputKeyValue from "../InputKeyValue";
import EditNavbar from "../EditNavbar";
import KeyDropdownValue from "../KeyDropdownValue";
import CustomButton from "../CustomButton";
import { SearchIcon, t } from "../../normalizer";

const UserAddressEditForm = (props) => {
  const {
    availableCountries,
    availableStates,
    first_name: firstName,
    last_name: lastName,
    phone,
    email,
    address1,
    city,
    address2,
    country = {},
    state = {},
    main_name: addressName,
    zip_code: zipCode,
    creating,
    errors = {},
    className,
    is_virtual: isVirtual = false,
    ...actions
  } = props;

  const [isValid, setIsValid] = React.useState(
    isVirtual
      ? (firstName && lastName && email && phone && addressName)
      : (address1 && zipCode && firstName && lastName && email && phone && addressName)
  );

  const validate = (data) => {
    let errors = {
        address1: undefined,
        zipCode: undefined,
        firstName: undefined,
        lastName: undefined,
        email: undefined,
        phone: undefined,
        addressName: undefined,
    };

    if (!data) {
      setIsValid(false);
      errors = isVirtual
        ? {
            firstName: "Por favor preencha o primeiro nome",
            lastName: "Por favor preencha o apelido",
            email: "Por favor preencha o email",
            phone: "Por favor preencha o telemóvel",
            addressName: "Por favor preencha o nome da morada",
          }
        : {
            address1: "Por favor preencha o endereço",
            zipCode: "Por favor preencha o código postal",
            firstName: "Por favor preencha o primeiro nome",
            lastName: "Por favor preencha o apelido",
            email: "Por favor preencha o email",
            phone: "Por favor preencha o telemóvel",
            addressName: "Por favor preencha o nome da morada",
          };
      return;
    }

    // Physical location fields are not shown (or required) for virtual
    // addresses, so skip their validation too.
    if (!isVirtual && !data.address1) {
      errors.address1 = "Por favor preencha o endereço";
    }
    if (!isVirtual && !data.zipCode) {
      errors.zipCode = "Por favor preencha o código postal";
    }
    if (!data.firstName) {
      errors.firstName = "Por favor preencha o primeiro nome";
    }
    if (!data.lastName) {
      errors.lastName = "Por favor preencha o apelido";
    }
    if (!data.email) {
      errors.email = "Por favor preencha o email";
    }
    if (!data.phone) {
      errors.phone = "Por favor preencha o telemóvel";
    }
    if (!data.addressName) {
      errors.addressName = "Por favor preencha o nome da morada";
    }
    if (Object.keys(errors).some(key => errors[key] !== undefined)) {
      setIsValid(false);
    } else {
      setIsValid(true);
    }
  };

  const handleChange = (e) => {
    e.preventDefault();
    const { addressName, address1, city, zipCode, firstName, lastName, email, phone } = e.currentTarget;
    validate({
      addressName: addressName.value,
      address1: isVirtual ? undefined : address1 && address1.value,
      city: isVirtual ? undefined : city && city.value,
      zipCode: isVirtual ? undefined : zipCode && zipCode.value,
      firstName: firstName.value,
      lastName: lastName.value,
      email: email.value,
      phone: phone.value,
    });

  };

  const handleOnSubmit = (event) => {
    event.preventDefault();
    const {
      address1,
      city,
      address2,
      zipCode,
      firstName,
      lastName,
      email,
      phone,
      addressName,
      country,
      state,
    } = event.target;
    const payload = {
      address1: isVirtual ? undefined : address1 && address1.value,
      city: isVirtual ? undefined : city && city.value,
      address2: isVirtual ? undefined : address2 && address2.value,
      zipCode: isVirtual ? undefined : zipCode && zipCode.value,
      firstName: firstName.value,
      lastName: lastName.value,
      email: email.value,
      phone: phone.value,
      addressName: addressName.value,
      country: isVirtual ? undefined : (country && country.value),
      state: isVirtual ? undefined : (state && state.value),
      // The address type never changes while editing (no switch is shown
      // here), but it must still be echoed back so the backend doesn't
      // reset it to physical (its default) on update.
      is_virtual: isVirtual,
    }
    actions.onEditSubmit(payload);
  };

  return (
    <form id="user-address-edit-form" onChange={handleChange} className={`user-address-form ${className}`} onSubmit={handleOnSubmit}>
      <div className="user-address-form-header">
        <div className="user-address-form-header-text">
          <h5 className="user-address-form-name">Edita dados de envio</h5>
          <div className="user-address-form-msg">
            Edite os campos abaixo e guarde as alterações
          </div>
        </div>
      </div>
      <div className="user-address-form-container">
        {/* Row 1 — Nome da morada 12/12 */}
        <div className="user-address-form-row">
          <div className="user-address-form-column4">
            <InputKeyValue
              title="Nome da morada"
              name="addressName"
              defaultValue={addressName}
              error={errors.addressName}
            />
          </div>
        </div>

        {/* Row 2 — Primeiro nome 6/12 | Apelido 6/12 */}
        <div className="user-address-form-row">
          <div className="user-address-form-column2">
            <InputKeyValue
              title="Primeiro nome"
              name="firstName"
              error={errors.firstName}
              defaultValue={firstName}
            />
          </div>
          <div className="user-address-form-column2">
            <InputKeyValue
              title="Apelido"
              name="lastName"
              error={errors.lastName}
              defaultValue={lastName}
            />
          </div>
        </div>

        {/* Row 3 — Email 6/12 | Telemóvel 6/12 */}
        <div className="user-address-form-row">
          <div className="user-address-form-column2">
            <InputKeyValue
              title="Email"
              name="email"
              error={errors.email}
              defaultValue={email}
            />
          </div>
          <div className="user-address-form-column2">
            <InputKeyValue
              title="Telemóvel"
              name="phone"
              error={errors.phone}
              defaultValue={phone}
            />
          </div>
        </div>

        {!isVirtual && (
          <>
            {/* Row 4 — Endereço 6/12 | Código Postal 3/12 | Cidade 3/12 */}
            <div className="user-address-form-row">
              <div className="user-address-form-column2">
                <InputKeyValue
                  leftIcon={<SearchIcon />}
                  title="Endereço"
                  name="address1"
                  error={errors.address1}
                  defaultValue={address1}
                />
              </div>
              <div className="user-address-form-column">
                <InputKeyValue
                  leftIcon={<SearchIcon />}
                  title="Código Postal"
                  name="zipCode"
                  error={errors.zipCode}
                  defaultValue={zipCode}
                />
              </div>
              <div className="user-address-form-column">
                <InputKeyValue /*disabled*/ title="Localidade" name="city" defaultValue={city} />
              </div>
            </div>

            {/* Row 5 — Restante morada 6/12 | País 3/12 | Região 3/12 */}
            <div className="user-address-form-row">
              <div className="user-address-form-column2">
                <InputKeyValue
                  title="Restante morada"
                  name="address2"
                  error={errors.address2}
                  defaultValue={address2}
                />
              </div>
              <div className="user-address-form-column">
                <KeyDropdownValue
                  title="País"
                  name="country"
                  selectedValue={country}
                  options={availableCountries}
                  onChange={actions.onCountryChange}
                  optionsId="id"
                  optionsLabel="name"
                  error={errors.country}
                  getOptionLabel={(option) => option.name}
                />
              </div>
              <div className="user-address-form-column">
                <KeyDropdownValue
                  title="Região"
                  name="state"
                  selectedValue={state}
                  optionsId="id"
                  optionsLabel="name"
                  error={errors.state}
                  options={availableStates}
                  onChange={actions.onStateChange}
                  getOptionLabel={(option) => option.name}
                />
              </div>
            </div>
          </>
        )}
      </div>
      <div className="user-address-form-actions">
        <CustomButton
          secondary
          className="mr-3"
          onClick={actions.onEditCancel}
        >
          {t("gamification2026.profile.cancel")}
        </CustomButton>
        <CustomButton 
          type={"submit"} 
          disabled={!isValid}
          form="user-address-edit-form">
          {t("gamification2026.profile.save")}
        </CustomButton>
      </div>
    </form>
  );
};
export default UserAddressEditForm;
